import { PaymentInstrumentIcon } from '@ocx-app/components/payment-instrument-icon';
import { ComponentPropsWithoutRef } from 'react';
import { PrepaidCardNumberField as PrepaidCardNumberFieldBase } from '@ocx/ui-forms';
import { PaymentInstrumentType } from '@ocx/graphql';

type PrepaidCardNumberFieldProps = Omit<ComponentPropsWithoutRef<typeof PrepaidCardNumberFieldBase>, 'InputProps'> & {
  InputProps?: Omit<ComponentPropsWithoutRef<typeof PrepaidCardNumberFieldBase>['InputProps'], 'endAdornment'>;
};

export const PrepaidCardNumberField = (props: PrepaidCardNumberFieldProps) => {
  const { InputProps, ...restProps } = props;
  return (
    <PrepaidCardNumberFieldBase
      {...restProps}
      InputProps={{
        ...InputProps,
        endAdornment: <PaymentInstrumentIcon type={PaymentInstrumentType.Prepaid} />,
      }}
    />
  );
};
